import { connect } from 'react-redux';
import { selectIsMobile } from 'selectors/ui';
import { selectActiveVenueId, selectUserId } from 'selectors/general';
import { closeModal } from 'components/Modal';
import { getKeyForUser, setKeyForUser } from 'helpers/local-storage';
import CalSyncTutorialModal from './CalSyncTutorialModal';
import { CALSYNC_TUTORIAL_MODAL_VIEWED_STORAGE_KEY } from '../CalSync.helpers';

const mapStateToProps = (state, ownProps) => {
  const isMobile = selectIsMobile(state);
  const userId = selectUserId(state);
  const isComplete = getKeyForUser(userId, CALSYNC_TUTORIAL_MODAL_VIEWED_STORAGE_KEY, false);
  const venueId = selectActiveVenueId(state);

  return {
    ...ownProps,
    isMobile,
    isComplete,
    venueId,
    passthroughProps: {
      userId,
    },
  };
};

const mapDispatchToProps = {
  closeModal,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { passthroughProps, ...restStateProps } = stateProps;
  const { userId } = passthroughProps;

  return {
    ...restStateProps,
    ...dispatchProps,
    markAsComplete: () => setKeyForUser(userId, CALSYNC_TUTORIAL_MODAL_VIEWED_STORAGE_KEY, true),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CalSyncTutorialModal);
